import { render, staticRenderFns } from "./editPack.vue?vue&type=template&id=47f6e982"
import script from "./editPack.vue?vue&type=script&lang=js"
export * from "./editPack.vue?vue&type=script&lang=js"
import style0 from "./editPack.vue?vue&type=style&index=0&id=47f6e982&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports